import { t } from "i18next";
import * as yup from "yup";

import {
  USAGE_GUIDE_QUESTION_MAX_LENGTH,
  USAGE_GUIDE_RICH_TEXT_MAX_LENGTH
} from "../../constants";

export const usageGuideFaqItemSchema = yup.object({
  question: yup
    .string()
    .trim()
    .max(
      USAGE_GUIDE_QUESTION_MAX_LENGTH,
      t("Question cannot be longer than 200 symbols")
    )
    .required(t("Question is required")),
  answer: yup
    .string()
    .trim()
    .max(USAGE_GUIDE_RICH_TEXT_MAX_LENGTH, t("Answer is too long"))
    .required(t("Answer is required")),
  isEnabled: yup.boolean().required()
});

// Every part of a guide is optional — a guide with nothing in it is pointless
// but not invalid, so the editor warns instead of blocking the save.
export const usageGuideSchema = yup.object({
  howToUseText: yup
    .string()
    .max(USAGE_GUIDE_RICH_TEXT_MAX_LENGTH, t("Text is too long"))
    .defined()
});
